
/**
 * Utility functions for managing document title
 */

/**
 * Safely sets the document title with error handling
 * @param title The title to set
 * @returns boolean indicating if the title was successfully set
 */
export const setDocumentTitle = (title: string): boolean => {
  try {
    // Using a safe approach to update the title
    if (typeof document !== 'undefined' && document.title !== undefined && title) {
      document.title = title;
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error setting document title:', error);
    return false;
  }
};

/**
 * Gets the current document title safely
 * @returns The current document title or an empty string if not available
 */
export const getDocumentTitle = (): string => {
  try {
    if (typeof document !== 'undefined' && document.title !== undefined) {
      return document.title;
    }
    return 'Communitly Platform'; // Default title as fallback
  } catch (error) {
    console.error('Error getting document title:', error);
    return 'Communitly Platform'; // Default title as fallback
  }
};
